import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import BetStatusIcon from './_bet-status-icon.js'

export default {
  name: 'ShareBetSummary',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    cashoutContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'center',
        },
      },
    },
    cashoutAmount: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    stake: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    betFundsInfo: {
      itemSpacing: '2px',
      style: {
        flexDirection: 'column',
      },
    },
    betStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          src: 'svg-sprites/generic/leg-status-open-icon.svg',
          style: {
            width: '16px',
          },
        },
        lost: {
          src: 'svg-sprites/generic/leg-status-lost-icon.svg',
          style: {
            width: '16px',
          },
        },
        void: {
          src: 'svg-sprites/generic/leg-status-void-icon.svg',
          style: {
            width: '16px',
          },
        },
        won: {
          src: 'svg-sprites/generic/leg-status-won-icon.svg',
          style: {
            width: '16px',
          },
        },
        cashedOut: {
          src: 'svg-sprites/generic/leg-status-cashed-out-icon.svg',
          style: {
            width: '16px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
